module.exports = __webpack_public_path__ + "static/media/FrankRuhlLibre_700Bold.45f0e946.ttf";